export default __webpack_public_path__ + "static/media/rarity-rare.355ec026.svg";